import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'umss-progress',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class UmssProgressComponent {
  @HostBinding('style.display') display = 'block';

  /** Content props */
  @Input() label?: string;
  @Input() showPercentage: boolean = true;

  /** Value props */
  @Input() value: number = 0; // Current value (0-100)
  @Input() max: number = 100; // Maximum value

  /** Variant props */
  @Input() size: 'Small' | 'Regular' | 'Large' = 'Regular';
  @Input() variant: 'Default' | 'Success' | 'Warning' | 'Error' = 'Default';

  /** State props */
  @Input() indeterminate: boolean = false; // For loading state
  @Input() striped: boolean = false;
  @Input() animated: boolean = false;

  /** Computed properties */
  get percentage(): number {
    return Math.min(Math.max((this.value / this.max) * 100, 0), 100);
  }

  get percentageText(): string {
    return `${Math.round(this.percentage)}%`;
  }

  get ariaValueNow(): number {
    return this.indeterminate ? 0 : this.value;
  }
}
